export const formatPortuguesePhone = (number: string): string => {
  // remove non-digits except leading +
  const cleaned = number.replace(/[^\d+]/g, '')

  // extract country code +351 and the rest
  const match = cleaned.match(/^\+351(\d{3})(\d{3})(\d{3})$/)

  if (!match) return number // fallback if format unexpected

  return `+351 ${match[1]} ${match[2]} ${match[3]}`
}
